/* eslint-disable react/prop-types */
import React  from "react";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

const CourseCardInstructor = ({ instructorHref, instructorName,customfontsize }) => {


  return (
    <Typography
      variant="h6" // Use a smaller variant for titles
      component={Link}
      to={"/course-details"}
      fontWeight={"bold"}
      sx={{
        mt: 1,
        display: "block", // Ensures the element is block-level and respects width
        width: "100%", // Ensure it's using the available width of the parent container
        overflow: "hidden", // Hide overflowed text
        textOverflow: "ellipsis", // Show ellipsis for overflowed text
        whiteSpace: "nowrap", // Prevent wrapping to a new line
        fontSize: `${0.6 * customfontsize}px`, // Set custom font size based on your variable
        textDecoration: "none", // Remove text decoration like underline
        textTransform: "capitalize", // Capitalize the first letter of each word
        color: "grey.600",
        "& span:hover": {
          color: "primary.main",
        },
      }}
      aria-label={`View details for ${instructorName}`} // Accessibility improvement
    >
      By <span>{instructorName}</span>
    </Typography>
  );
};

export default CourseCardInstructor;
